import { handleData } from "../api";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { IoCheckmarkDoneSharp, IoChevronBack, IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";
import '../css/signupforms.css';


const PWD_REGEX = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,30}$/;



const ResetPassword = () => {

    const navigate = useNavigate();
    const redirectPath = '/';


    const [newPassword, setNewPassword] = useState({
        password: "",
        second: ""
    });
    const [passwordChangeSuccess, setPasswordChangeSuccess] = useState(false);
    const [passwordChangeNoSuccess, setPasswordChangeNoSuccess] = useState(false);

    const [showpassword, setShowPassword] = useState(false);
    const [validPwd, setValidPwd] = useState(false);
    const [pwdFocus, setPwdFocus] = useState(false);
    const [validMatch, setValidMatch] = useState(false);




    const token = window.location.search.split('token=')[1];

    useEffect(() => {
        const result = PWD_REGEX.test(newPassword.password);
        setValidPwd(result);
    },[newPassword.password]);

    useEffect(() => {
        const result = newPassword.second && newPassword.password === newPassword.second;
        setValidMatch(result);
    },[newPassword.password, newPassword.second]);





    const handleChange = (e) => {
        setNewPassword({
            ...newPassword,
            [e.target.name]: e.target.value
        });
    }

    const toggleShowPassword = () => {
        setShowPassword((prevShowpassword) => !prevShowpassword);
    }




    const handleSubmit = async(e) => {
        e.preventDefault();
        if (validMatch && validPwd) {
            const data = {
                method: 'PATCH',
                path: `auth/resetpassword/${token}`,
                input: {
                    token: token,
                    password: newPassword.password
                }
            }
            const result = await handleData(data);
            if (result.data.success) {
                setPasswordChangeSuccess(true);
                waitForwarding();
            } else {
                setPasswordChangeNoSuccess(true);
            }
        } else {
            setPasswordChangeNoSuccess(true);
        }
    }

    const waitForwarding = () => {
        setTimeout(navigate, 3000, redirectPath, { replace: true});
    }


    return (
        <div className="resetPasswordSection">
            <h2>Wachwoord opnieuw instellen</h2>
            <div className="aanmeldInputContainer">
                <form onSubmit={handleSubmit}>
                    <div className="newPasswordInput aanmeldBody">
                        <div className="inputLine inputBox">
                            <label htmlFor="password">
                                Nieuw wachtwoord: 
                                {
                                    validPwd && 
                                    <span className="checkmark">
                                        <IoCheckmarkDoneSharp />
                                    </span>
                                }
                                {
                                    !validPwd &&
                                    <span className="notValid">
                                        <IoChevronBack />
                                    </span>
                                }

                            </label>
                            <div className="passwordContainer">
                                <input 
                                    type={showpassword ? "text" : "password"}
                                    name="password"
                                    // minLength="6"
                                    onChange={handleChange}
                                    value={newPassword.password}
                                    required
                                    onFocus={() => setPwdFocus(true)}
                                    onBlur={() => setPwdFocus(false)}

                                />
                                <span onClick={toggleShowPassword}>
                                    {showpassword ?<IoEyeOutline /> : <IoEyeOffOutline />}
                                </span>
                            </div>
                            {
                            (pwdFocus && !validPwd) &&
                            <p className="inputInfo">
                                Minimaal 8 karakters. <br />
                                Ten minste 1 letter, 1 getal en 1 speciaal karakter. <br />
                            </p>    
                            }
                        </div>
                        
                        <div className="inputLine inputBox">
                            <label htmlFor="password">
                                Herhaal wachtwoord: 
                                {
                                    validMatch && 
                                    <span className="checkmark">
                                        <IoCheckmarkDoneSharp />
                                    </span>
                                }
                                {
                                    !validMatch &&
                                    <span className="notValid">
                                        <IoChevronBack />
                                    </span>
                                }

                            </label>
                            <div className="passwordContainer">
                                <input 
                                    type={showpassword ? "text" : "password"}
                                    name="second"
                                    onChange={handleChange} 
                                    value={newPassword.second}
                                    required
                                />
                                <span onClick={toggleShowPassword}>
                                    {showpassword ?<IoEyeOutline /> : <IoEyeOffOutline />}
                                </span>
                            </div>
                        </div>
                        
                        <div className="buttonContainer">
                            <button 
                                className={`button small passwordResetConfirm ${validPwd && validMatch ? "valid" : "invalid"}`} onClick={handleSubmit}
                                disabled={!validPwd || !validMatch}
                            >
                                Bevestig nieuw wachtwoord
                            </button>
                        </div>
                        {passwordChangeSuccess && <p>Je wachtwoord is nu gewijzigd</p>}
                        {passwordChangeNoSuccess && <p>Wachtwoord wijziging niet gelukt.</p>}
                    </div>
                </form>
            </div>
        </div>
    );
}

export default ResetPassword;